<template>
  <div class="body">
    <Yukleniyor :data="lo"></Yukleniyor>
    <hr style="margin: 0">
    <div class="detay">
      <div class="sayfahead tek buyukhead">
        <h1>Mağaza</h1><br>
        <el-popover v-if="Urunler.length"
                    placement="left"
                    width="400"
                    v-model="showDialog"
                    trigger="manual">
          <div class="Sepet">
            <h5 class="text-center text-success">Sipariş Listesi</h5>
            <table class="table">
              <thead>
              <tr>
                <th>Ürün Kodu</th>
                <th class="text-right">Adet</th>
                <th class="text-right">Birim</th>
                <th class="text-right">Toplam</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(u,index) in Urunler">
                <td>#{{u.id}}</td>
                <td class="text-right">
                  <el-input type="number" v-model="u.Adet" @change="reHesap" style="width: 100px"
                            size="mini"></el-input>
                </td>
                <td class="text-right">{{u.Fiyat}}</td>
                <td class="text-right">{{u.Tutar}}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th><a @click="reHesap" href="#">Siparişi Güncelle</a></th>
                <th colspan="2" class="text-right">ÖDENECEK TOPLAM</th>
                <th class="text-right">{{AltToplam}}<sup>TL</sup></th>
              </tr>
              </tfoot>
            </table>
            <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
              <p class="text-center m-0 font-weight-bold">Sipariş İletişim Bilgileri</p>
              <el-form-item label="İsim Soyisim" prop="Isim">
                <el-input v-model="Form.Isim" size="small"></el-input>
              </el-form-item>
              <el-form-item label="Telefon" prop="Telefon">
                <el-input v-model="Form.Telefon" size="small" v-mask="'### ### ## ##'"></el-input>
              </el-form-item>
              <el-form-item class="text-center" label="Ödeme Şekli" prop="OdemeSekli">
                <el-radio-group v-model="Form.OdemeSekli" size="mini">
                  <el-radio-button label="Havale/EFT"></el-radio-button>
                  <el-radio-button label="Kredi Kartı"></el-radio-button>
                  <el-radio-button label="Kredi Kartına Taksit"></el-radio-button>
                </el-radio-group>
              </el-form-item>

            </el-form>
            <el-button class="btn-block" type="success" @click="Submit" size="small">Siparişi Onayla</el-button>
            <br>
            <el-button class="btn-block" type="warning" @click="showDialog=false" size="mini">Siparişe Devam Et
            </el-button>
          </div>

          <el-button slot="reference" size="small" @click="showDialog = !showDialog" type="success">Sipariş Listesi
          </el-button>
        </el-popover>

      </div>
      <div class="icerik" style="height: calc(100vh)">
        <el-row :gutter="24" v-for="k in Kategori" v-if="k.Urunler">
          <h2 class="KategoriBaslik">{{k.Adi}}</h2>
          <el-col :span="4" v-for="u in k.Urunler">
            <el-card :body-style="{ padding: '0px' }">
              <img :src="u.Resim"
                   class="image" width="100%">
              <div class="UrunDetay">
                <h4>Kod: <b>#{{u.id}}</b></h4>
                <h5>{{u.Adi}}</h5>
                <p>{{u.Aciklama}}</p>
                <div class="text-center"><span>{{u.FiyatText}}<sup>TL</sup></span></div>
                <div class="bottom clearfix">
                  <el-button type="text" class="button text-center btn-block" @click="Sepet(u)">Satın Al</el-button>
                </div>
              </div>
              <p class="Firma">
                <el-tooltip class="item" effect="dark"
                            :content="'Aidatım güvencesiyle '+u.Magaza+' tarafından teslim edilecektir.'"
                            placement="bottom">
                  <b><i class="el-icon-info"></i> {{u.Magaza}}</b>
                </el-tooltip>
              </p>
            </el-card>
          </el-col>
        </el-row>

      </div>
    </div>

  </div>
</template>

<script>
  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        showDialog: false,
        ModalOlayi: false,
        Kategori: null,
        Slayt: null,
        Urun: null,
        Urunler: null,
        AltToplam: null,
        Form: {
          Sepet: null,
          Odenecek: null,
          Isim: null,
          Telefon: null,
          OdemeSekli: 'Havale/EFT'
        },
        FormHata: {
          Isim: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          OdemeSekli: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
      }
    },
    methods: {
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {

            // EKLE
            this.$store.dispatch("Post", {...this.Form, path: 'spesiyal/magaza'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.showDialog = false
                  localStorage.removeItem('Sepet');
                  this.Urunler = [];

                  this.$alert(response.Mesaj, 'Siparişiniz Alındı', {
                    confirmButtonText: 'Kapat',
                    dangerouslyUseHTMLString: true,
                  });
                } else {
                  this.$message.error(response.Mesaj);
                }
              })

          }
        });
      },
      indexWhere(array, conditionFn) {
        const item = array.find(conditionFn)
        return array.indexOf(item)
      },
      Sepet(u) {
        this.showDialog = true
        this.Urunler = localStorage.getItem('Sepet') ? JSON.parse(localStorage.getItem('Sepet')) : []
        var UrunVarmi = this.Urunler.filter(c => c.id.includes(u.id))[0];
        if (UrunVarmi) {
          var index = this.indexWhere(this.Urunler, item => item.id === u.id);
          if (index > -1) this.Urunler.splice(index, 1);
          this.Urunler.push({
            id: u.id,
            Adet: UrunVarmi.Adet + 1,
            Adi: u.Adi,
            Fiyat: u.Fiyat,
            FiyatText: u.FiyatText,
            Tutar: (UrunVarmi.Adet + 1) * u.Fiyat,
            Resim: u.Resim
          });

        } else {
          this.Urunler.push({
            id: u.id,
            Adet: 1,
            Adi: u.Adi,
            Fiyat: u.Fiyat,
            FiyatText: u.FiyatText,
            Tutar: 1 * u.Fiyat,
            Resim: u.Resim
          });
        }
        //this.SepetAc += 1;
        this.$message.success("Ürün Sipariş Listesine Eklendi");
        this.reHesap();

      },

      reHesap() {
        this.AltToplam = 0;
        var Urunler = this.Urunler;
        Urunler.forEach(function (e, i) {
          if (e.Adet === '0') Urunler.splice(i, 1);
        });
        this.Urunler = Urunler;
        this.Urunler.forEach(e => e.Tutar = e.Adet * e.Fiyat);
        this.Urunler.forEach(e => this.AltToplam += e.Tutar);

        this.Form.Sepet = this.Urunler
        this.Form.Odenecek = this.AltToplam
        localStorage.setItem('Sepet', JSON.stringify(this.Urunler));

      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'spesiyal/magaza'})
          .then(response => {
            this.lo = false;
            this.Kategori = response.Kategori;
          });
      }
    },
    created() {
      this.SayfaYukle();
      this.Urunler = localStorage.getItem('Sepet') ? JSON.parse(localStorage.getItem('Sepet')) : [];
      this.reHesap();
      var Kullanici = JSON.parse(localStorage.getItem('_ai'));
      this.Form.Isim = Kullanici.isim
      this.Form.Telefon = Kullanici.Telefon
    }
  }
</script>

<style scoped>
  .buyukhead h1 {
    font-size: 40px;
  }

  .buyukhead {
    padding: 40px 50px !important;
    background-image: url(https://cdn.mudu.pro/Design/magaza.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    text-align: center;
    margin-left: -20px;
    margin-right: -20px;
    top: -20px;
    background-position: center;
  }

  .Sepet {
    position: relative;
    display: block;
    width: 400px;
    padding: 10px;
  }

  h2.KategoriBaslik {
    font-size: 24px;
    padding: 0 5px;
    color: #4084f1;
    border-left: 20px solid #da4537;
    margin: 15px;
  }

  .UrunDetay {
    padding: 10px;
  }

  .UrunDetay h4 {
    font-size: 16px;
    color: #d94537;
  }

  .UrunDetay h5 {
    font-size: 14px;
  }

  .UrunDetay p {
    font-size: 12px;
    color: #333;
    margin: 0;
    height: 70px;
    overflow: hidden;
  }

  p.Firma {
    font-size: 12px;
    text-align: center;
    margin: 0;
    background: #CCC;
    color: #000;
    padding: 5px;
    cursor: pointer;
  }

  .UrunDetay span {
    font-size: 20px;
    font-weight: bold;
    color: #01c490;
  }
</style>



// WEBPACK FOOTER //
// src/pages/_Magaza/index.vue